<div *ngIf="formElementBlockConfig" [formGroup]="form" class="form-details__block">
  <ws10-form-element-block [formElementBlockConfig]="formElementBlockConfig" [required]="formField.required ? '' : null"
    [formControlName]="formControlName"></ws10-form-element-block>
</div>
